import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { AccessibilityStatementComponent } from './accessibility-statement/accessibility-statement.component';
import { LogoutComponent } from './logout/logout.component';
import { WFP_PATHS } from './constants/routes';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: WFP_PATHS.LOGIN },
  { path: WFP_PATHS.LOGIN, loadChildren: () => import('./login/login.module').then((m) => m.LoginModule) },
  { path: WFP_PATHS.SESSION, loadChildren: () => import('./session/session.module').then((m) => m.SessionModule) },
  { path: WFP_PATHS.STATEMENT, component: AccessibilityStatementComponent },
  { path: WFP_PATHS.LOGOUT, component: LogoutComponent },
  { path: '**', redirectTo: WFP_PATHS.LOGIN }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
  providers: [{ provide: LocationStrategy, useClass: PathLocationStrategy }]
})
export class AppRoutingModule {}
